<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="text-primary" width="42" height="42" viewBox="0 0 42 42">
        <rect width="42" height="42" rx="4" fill="#edeef0" />
        <path d="M90.334,0h3.726a1.115,1.115,0,0,1,1.118,1.118V8.943h4.085a.93.93,0,0,1,.657,1.588L92.836,17.62a.9.9,0,0,1-1.272,0L84.47,10.531a.93.93,0,0,1,.657-1.588h4.09V1.118A1.115,1.115,0,0,1,90.334,0Z" transform="translate(-71.195 12)" class="fill-current"/>
    </svg>
</template>